import React, {
  PropTypes as T,
  Component,
} from 'react';
import radium from 'radium';

import ProgressNavi from '../ProgressNavi.js';
import DetectionIntroPlayer from '../../containers/Detections/DetectionIntroPlayer.js';
import DetectionStartModal from '../../containers/Detections/DetectionStartModal.js';
import Helpers from '../../helpers';

const styles = {
  wrap: {
    padding: 10,
    display: 'block',
    height: 'calc(100vh - 150px)',
  },
  wrap_TV: {
    padding: '35% 10px 10px',
    display: 'block',
    height: 'calc(100vh - 150px)',
    overflow: 'hidden',
  }
};

export const ON = Symbol('ON');
export const OFF = Symbol('OFF');

class DetectionIntroViewer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: ON,
      playing: false,
      volume: 50,
      muted: false,
    };
  }

  render() {
    const {
      params,
    } = this.props;

    var wrap = styles.wrap;

    if (Helpers.Session.isViaTV()) {
      wrap = styles.wrap_TV;
    }

    return (
      <div style={wrap}>
        <ProgressNavi
          step={parseInt(params.key, 10)}
          count={5}
          color="#FBBB0C" />
        <DetectionIntroPlayer
          stepKey={parseInt(params.key, 10)}
          count={5} />
        <DetectionStartModal />
      </div>
    );
  }
}

DetectionIntroViewer.propTypes = {
  params: T.shape({
    key: T.string,
  }),
};

export default radium(DetectionIntroViewer);



// WEBPACK FOOTER //
// ./components/Detections/DetectionIntroViewer.js